import { TaxiLandmarkApiTaxiLandmarkCreateRequest } from "../../openapi/api";
import appApiClient from "./coreApiClient";
import useBaseMutation from "./useBaseMutation";

export const useTaxiLandmarkCreateMutation = () =>
  useBaseMutation({
    mutationFn: (req: TaxiLandmarkApiTaxiLandmarkCreateRequest, config) =>
      appApiClient.taxiLandmarkApi.taxiLandmarkCreate(req, config),
  });
